<h1 mat-dialog-title>Actividades</h1>
<div>
    <mat-tab-group>
        <mat-tab label="Actividades del Turno">

            <div class="observation-table-scroll">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <table style="width:100%" *ngIf="!loading" class="table-content">
                    <tr>
                        <th class="cell-date">Fecha</th>
                        <th>Acción</th>
                        <th class="cell-date">Usuario</th>
                    </tr>

                    <tr *ngFor="let log of medicalAppointmentLogView">
                        <td class="cell-date">{{ log.Date }}</td>
                        <td>
                            <div style="width:100%; max-width:400px; word-wrap: break-word">{{log.Log}} </div>
                        </td>
                        <td class="cell-date">{{log.User}}</td>
                    </tr>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Actividades de Informes">

            <div class="observation-table-scroll">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <table style="width:100%" *ngIf="!loading" class="table-content">
                    <tr>
                        <th class="cell-date">Fecha</th>
                        <th>Acción</th>
                        <th class="cell-date">Usuario</th>
                    </tr>

                    <tr *ngFor="let log of reportStudyLogView">
                        <td class="cell-date">{{ log.Date }}</td>
                        <td>
                            <div style="width:100%; max-width:400px; word-wrap: break-word">{{log.Log}} </div>
                        </td>
                        <td class="cell-date">{{log.User}}</td>
                    </tr>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Actividades del paciente">

            <div class="observation-table-scroll">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <table style="width:100%" *ngIf="!loading" class="table-content">
                    <tr>
                        <th class="cell-date">Fecha</th>
                        <th>Acción</th>
                        <th class="cell-date">Usuario</th>
                    </tr>

                    <tr *ngFor="let log of patientLogView">
                        <td class="cell-date">{{ log.Date }}</td>
                        <td>
                            <div style="width:100%; max-width:400px; word-wrap: break-word">{{log.Log}} </div>
                        </td>
                        <td class="cell-date">{{log.User}}</td>
                    </tr>
                </table>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>